import { libraryEmptyState, type LibraryEmptyStateInfo } from './libraryEmptyState.ts';
import type { LibraryFilterState } from './libraryFilterState.ts';

/**
 * The one line the Library shows in place of a body it has nothing to fill.
 *
 * The decks page's `DeckEmptyState` for this shelf, and quiet for the same
 * reason: a sentence and a single button in the weight of the rest of the page,
 * never a centred illustration. Which sentence is `libraryEmptyState.ts`'s
 * decision; everything here is the rendering.
 *
 * Not a live region — `DeckSearchBar` already announces "Showing 0 of 22 items"
 * politely once the typing settles, and two regions firing on one keystroke is
 * how a screen reader reads a search twice.
 */
type Props = {
  filters: LibraryFilterState;
  /** The page's clear-all, the same one the chip row's button calls. */
  onClearFilters: () => void;
  onNewItem: () => void;
};

export default function LibraryEmptyState({ filters, onClearFilters, onNewItem }: Props) {
  const info: LibraryEmptyStateInfo = libraryEmptyState(filters);
  return (
    <div className="deck-empty" data-empty={info.key}>
      <p className="deck-empty__line">{info.message}</p>
      {info.action && (
        <button
          type="button"
          className={info.action.kind === 'new' ? 'btn btn--primary btn--sm' : 'btn btn--ghost btn--sm'}
          onClick={info.action.kind === 'new' ? onNewItem : onClearFilters}
        >
          {info.action.label}
        </button>
      )}
    </div>
  );
}
